export class JobCommitPrototyp{
  public id: number
  public analyze_note: any
  public dicht_pruef: boolean
  public finish_notes: any
  public funktion_pruef: boolean
  public orderline_ids: Array<any>
  public schaetzline_ids: Array<any>
  public workline_ids: Array<any>
  public signature: any
  public orderline: any = []
  public workline: any
  public schaetzline: any
}

export class OrderlinePrototyp{
  public product_id: number
  public product_uom: number
  public qty: number
  public qty_real: number
}

export class SchaetzlinePrototyp{
  public dauer: number
  public description: string
  public name: string
  public order_id: number
}

export class WorklinePrototyp{
  public von: number
  public bis: number
  public description: string
  public name: string
  public monteur_id: number
  public dauer: number
}



// WEBPACK FOOTER //
// ./src/providers/job-commit/job-commit.prototyp.ts